import { Skeleton, Space } from "antd";

const TableSkeleton = ({ tableType }) => {
  return (
    <>
      {tableType === "approve" ? (
        <Space style={{ padding: "10px 0px" }}>
          <Skeleton.Input active={true} size={"small"} />
          <Skeleton.Input active={true} size={"small"} />
        </Space>
      ) : null}
      {tableType === "request" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 0px",
            width: "100%",
          }}
        >
          <Skeleton.Input active={true} size="large" />
          <Skeleton.Button active={true} size="large" />
        </div>
      ) : null}
      <Skeleton.Input
        active={true}
        block={true}
        style={{ height: "100px", marginBottom: "10px" }}
      />
      <Skeleton.Input active={true} block={true} style={{ height: "300px" }} />
    </>
  );
};

export default TableSkeleton;
